"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendFieldPaths = appendFieldPaths;
exports.mapDataAttrsToDataSet = mapDataAttrsToDataSet;
exports.pickDataAttrs = pickDataAttrs;
exports.setFieldPath = setFieldPath;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// type PropType = { [Key: string]: unknown }

/**
 * Returns an object containing all props that start with `data-`
 *
 * @param props
 * @returns An object containing all `data-` props from `props`
 */
function pickDataAttrs(props) {
  return Object.entries(props).reduce((dataAttrs, _ref) => {
    var [key, value] = _ref;
    if (typeof value === 'string' && key.startsWith('data-')) {
      dataAttrs[key] = value;
    }
    return dataAttrs;
  }, {});
}

/**
 * Converts props starting with `data-` to a `dataSet` object
 *
 * @param props
 * @param toCamelCase Optional prop
 * @returns An object containing all keys starting `data-` from `props` as a `dataSet` object
 */
function mapDataAttrsToDataSet(props, toCamelCase) {
  return Object.entries(props).reduce((dataAttrs, _ref2) => {
    var [key, value] = _ref2;
    if (typeof value === 'string' && key.startsWith('data-')) {
      key = key.replace(/^data-/, '');
      if (toCamelCase) {
        key = key.replace(/-(.)/g, (_, p1) => {
          return p1.toUpperCase();
        });
      }
      dataAttrs[key] = value;
    }
    return dataAttrs;
  }, {});
}

/**
 * Adds `data-sb-field-path` with value `fieldPath` to the `props` object
 *
 * @param props
 * @param fieldPath
 * @returns
 */
function setFieldPath(props, fieldPath) {
  return _objectSpread(_objectSpread({}, props), {}, {
    'data-sb-field-path': fieldPath
  });
}
/**
 * Adds `data-sb-field-path` appending to the parent field path an array of strings
 *
 * @param  {} props
 * @param  {string[]} fieldPaths array of strings to be appended
 */
function appendFieldPaths(props, fieldPaths) {
  var parentFieldPath = props['data-sb-field-path'];
  if (!parentFieldPath || !fieldPaths.length) {
    return props;
  }
  return _objectSpread(_objectSpread({}, props), {}, {
    'data-sb-field-path': "".concat(parentFieldPath, " ") + fieldPaths.map(fieldPath => "".concat(parentFieldPath).concat(fieldPath)).join(' ')
  });
}